class RefundReq {
    constructor() {
        this.accountingEntryId = undefined;
        this.refundType = undefined;
        this.creatorId = undefined;
        this.packageId = undefined;
    }
}
export default RefundReq;